import React from 'react'
import './footer.css';

const Footer = () => {
  return (
    <div className="footer-container">
        <p className="footer-text">© {new Date().getFullYear()} NK Repuestos Marcos Paz. Todos los derechos reservados.</p>
    </div>
  )
}

export default Footer